import React, { useState } from "react";
import ReactPlayer from "react-player";

import campus from "../../video/Virtual Tour.mp4";
import "./Landing.css";
import Slider1 from "../../image/final/s1.jpg";
import Slider2 from "../../image/event_cover.jpg";
import Slider3 from "../../image/final/Planting.jpg";
import Slider4 from "../../image/final/Pedagogy.jpg";
import Slider5 from "../../image/final/slider5.jpg";
import Slider6 from "../../image/final/LifeSkillCurricullum.jpg";
import Slider7 from "../../image/final/library.jpg";
import Slider8 from "../../image/final/slider1.jpg";
import Slider9 from "../../image/final/NEP.jpg";
import Slider10 from "../../image/final/slider2.jpg";

import { Link } from "react-router-dom";
// import homeBanner1 from "../../image/home_banner/admissionbanner1.jpg";
// import homeBanner2 from "../../image/home_banner/admissionbanner2.jpg";
import homeBanner3 from "../../image/home_banner/banner3.webp";
import homeBanner4 from "../../image/home_banner/Home_banner.webp";

import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

import { Pagination, Navigation, Autoplay } from "swiper";

import { GiSpeaker, GiSpeakerOff } from "react-icons/gi";

function Landing({ video, cover }) {
  const [isMuted, setIsMuted] = useState(true);

  return video ? (
    <div className="position-relative margin8">
      {/* <ReactPlayer
        url={campus}
        loop={true}
        muted={isMuted}
        playing={true}
        controls={false}
        width="100%"
        className="landing_video"
      /> */}
     <div id="carouselExampleIndicators" className="carousel slide ">
        <div>
          <div className="carousel-indicators d-none">
            <button
              type="button"
              data-bs-target="#carouselExampleIndicators"
              data-bs-slide-to="0"
              className="active"
              aria-current="true"
              aria-label="Slide 1"
            ></button>
            <button
              type="button"
              data-bs-target="#carouselExampleIndicators"
              data-bs-slide-to="1"
              aria-label="Slide 2"
            ></button>
            <button
              type="button"
              data-bs-target="#carouselExampleIndicators"
              data-bs-slide-to="2"
              aria-label="Slide 3"
            ></button>
          </div>
          <div className="carousel-inner">
            <div className="carousel-item active">
              <Link to="/admissions" className="landing-admissions-banner">
                <img
                  src={homeBanner4}
                  alt="Student showcasing a robotics project in a STEAM classroom"
                  className="landing-admissions-banner-image"
                />
                <div className="landing-admissions-banner-content">
                  <h1 className="landing-admissions-banner-headline">
                    <span>Big Ideas Begin Here.</span>
                    <span className="landing-admissions-banner-headline-accent">
                      Future Leaders Start Here.
                    </span>
                  </h1>
                  <p className="landing-admissions-banner-description">
                    Discover a world of learning where academic excellence meets
                    creativity, innovation, hands-on STEAM experiences, and
                    holistic development.
                  </p>
                  <p className="landing-admissions-banner-grades">
                    Nursery - Grade 5
                  </p>
                  <span className="landing-admissions-banner-cta">
                    APPLY FOR ADMISSION
                  </span>
                </div>
              </Link>
            </div>
            {/* <div className="carousel-item">
            <Link to="/admissions">
              <img
                src={homeBanner2}
                width="100%"
              />
              </Link>
            </div>
            <div className="carousel-item">
            <Link to="/admissions">
              <img
                src={homeBanner3}
                width="100%"
              />
              </Link>
            </div> */}
          </div>
          <button
            className="carousel-control-prev d-none"
            type="button"
            data-bs-target="#carouselExampleIndicators"
            data-bs-slide="prev"
          >
            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
            <span className="visually-hidden">Previous</span>
          </button>
          <button
            className="carousel-control-next d-none"
            type="button"
            data-bs-target="#carouselExampleIndicators"
            data-bs-slide="next"
          >
            <span className="carousel-control-next-icon" aria-hidden="true"></span>
            <span className="visually-hidden">Next</span>
          </button>         
        </div>
      </div>
    </div>
  ) : (
    <div className="cover_img_cont">
      <img src={cover} alt="images" className="cover_img" />
    </div>
  );
}

export default Landing;
